import { render, staticRenderFns } from "./ReferentsManager.vue?vue&type=template&id=87177d58&"
import script from "./ReferentsManager.vue?vue&type=script&lang=js&"
export * from "./ReferentsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports